import Vue from "vue";
import Router from "vue-router";
import HeaderMainLayout from "@/layouts/HeaderMainLayout";
import publicWelfare from "@/views/publicWelfare/index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () => import(/* webpackChunkName: "home" */ "./views/home")
        }
      ]
    },
    {
      path: "/download_app",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(
              /* webpackChunkName: "download_app" */ "./views/download_app"
            )
        }
      ]
    },
    {
      path: "/publicWelfare",
      name: "publicWelfare",
      component: HeaderMainLayout,
      children: [{ path: "", component: publicWelfare }]
    },
    {
      path: "/company",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "company" */ "./views/company")
        }
      ]
    },
    {
      path: "/partner",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "parner" */ "./views/partner")
        }
      ]
    },
    {
      path: "/county",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "county" */ "./views/county")
        }
      ]
    },
    {
      path: "/cooperation",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "cooperation" */ "./views/cooperation")
        }
      ]
    },
    {
      path: "/driver",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "driver" */ "./views/driver")
        }
      ]
    },
    {
      path: "/information",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "information" */ "./views/information")
        }
      ]
    },
    {
      path: "/commonweal",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "commonweal" */ "./views/commonweal")
        }
      ]
    },
    {
      path: "/news/:id",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () => import(/* webpackChunkName: "news" */ "./views/news")
        }
      ]
    },
    {
      //新闻详情
      path: "/news/detail/:id",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "news" */ "./views/news/detail")
        }
      ]
    },
    {
      path: "/help",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () => import(/* webpackChunkName: "help" */ "./views/help")
        }
      ]
    },
    {
      path: "/sales",
      component: HeaderMainLayout,
      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "sale" */ "./views/sales")
        }
      ]
    },
    {
      path: "*",
      component: () =>
        import(/* webpackChunkName: "404" */ "./views/error-page/404")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
